module.exports = __webpack_public_path__ + "img/waiting-clock.85d39a83.svg";